// removed by extract-text-webpack-plugin
module.exports = {"modal":"fowjS","isShown":"_3s-BX","fadeIn":"_1KSEb","close":"_2mPmn","container":"_1Asrd","image":"_7Au1Q"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/styles.css
 ** module id = 343
 ** module chunks = 0
 **/